// Because there are all brand names, it is unnecessary for them to be translatable.
export default [
    {tag: 'scratch', intlLabel: 'Scratch'},
    {tag: 'tw', intlLabel: 'TurboWarp'},
    {tag: 'cysoeditor-hub', intlLabel: 'CYSCREXTHUB'}
];
